import { call, put, takeEvery } from 'redux-saga/effects';
import { createLeadAffiliate } from '../../requests/create_affiliate_request';
import { createAffiliateRequestSuccess, createAffiliateRequestFailure } from '../actions/create_affiliate.actions';
import { CREATE_AFFILIATE_REQUEST } from '../constants/create_affiliate.constants';
import { message_success, message_error } from '../../../../../components/Message';

function* createAffiliateSagaRequest({ payload }) {
    const { result, options, error } = yield call(createLeadAffiliate, payload);
    if (result) {
        yield put(createAffiliateRequestSuccess(options));
        message_success('Affiliate created successfully!');
    } else {
        yield put(createAffiliateRequestFailure(error));
        if (error.name === 'DocumentAlreadyExistsError') {
            message_error('Affiliate already exist with this old crm affiliate id');
        }
    }
}

export default function* createAffiliateSaga() {
    yield takeEvery(CREATE_AFFILIATE_REQUEST, createAffiliateSagaRequest);
}



// WEBPACK FOOTER //
// ./src/modules/PlatformManagement/Manage_affiliates_create/redux/sagas/create_affiliate.saga.js